import React, { useRef, useState, useCallback } from "react";
import PropTypes from "prop-types";
import Modal from "components/base/SimpleModal";
import AvatarEditor from "react-avatar-editor";
import Slider from 'rc-slider';
import classNames from "classnames";

import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority,
} from "app/PopupHolder";

import css from "./style.scss";


/**
 * Renders Image crop modal
 * Returns data URL of cropped image on submit
 */
const ImageCropModal = ({ closePopup, autoWidth, onSubmit, image }) => {
  const editorRef = useRef(null);
  const [scale, setScale] = useState(1.2);

  const handleClose = useCallback(() => {
    closePopup?.();
  }, [closePopup]);

  const handleSubmit = useCallback(() => {
    let result = null;
    if (editorRef.current) {
      try {
        const canvas = editorRef.current.getImageScaledToCanvas();
        result = canvas.toDataURL();
      } catch (e) {
        // fallback: do nothing, result stays null
      }
    }
    if (onSubmit) onSubmit(result);
    handleClose();
  }, [onSubmit, closePopup, handleClose]);

  const modalBody = (
    <div>
      <div>
        <AvatarEditor
          ref={editorRef}
          image={image}
          width={300}
          height={300}
          border={40}
          color={[255, 255, 255, 0.6]}
          scale={scale}
        />
      </div>
      <div className={css.controls}>
        <div className={classNames(css.controlRow)}>
          <Slider 
            min={1} 
            max={5} 
            step={0.1} 
            value={scale} 
            onChange={(v) => setScale(parseFloat(v))} 
            classNames={{
                track: css.rcSliderTrack,
                handle: css.rcSliderHandle,
                rail: css.rcSliderRail,
            }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      uniqueId="ImageCropModal"
      onCancel={handleClose}
      onSubmit={handleSubmit}
      title="Choose Image"
      cancelText="Cancel"
      submitText="Save"
      modalClassName={css.clsDNCPolicyModal}
      modalBody={modalBody}
      modalCancelBtnClassName={css.clsModalCancelBtn}
      modalFooterWrapperClassName={css.clsModalFooterWrapperClassName}
    />
  );
};

export default ImageCropModal;

const registrationId = getPopupRegistration(ImageCropModal);

ImageCropModal.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.HIGHEST });
ImageCropModal.close = () => closePopup({ popup: registrationId });

ImageCropModal.propTypes = {
  closePopup: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  autoWidth: PropTypes.bool,
  image: PropTypes.string.isRequired,
};
